module.exports = __webpack_public_path__ + "static/img/sec2-bg@t.e1dd196.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec2-bg@t.png
// module id = x6gC
// module chunks = 0